import Grid from "@mui/material/Grid";

import ArrowDown from "../../../assets/images/arrow-down.svg";
import ArrowUp from "../../../assets/images/arrow-up.svg";
import { FlexGrid } from "../../common/grid/components/FlexGrid";
import {
  Item,
  MenuButton,
  MenuDivider,
  StyledMenu,
  StyledMenuItem,
  Subtitle,
  Title,
} from "../styles/ProductStyles";
import type { ProductDefinition } from "../types/productTypes";

type ProductHeaderProps = {
  product: ProductDefinition;
  productsMenu: string[];
  anchorEl: HTMLElement | null;
  isMenuOpen: boolean;
  onOpenMenu: (element: HTMLElement) => void;
  onCloseMenu: () => void;
  onSelectProduct: (productTitle: string) => void;
  onEditPlanClick: () => void;
};

export const ProductHeader = ({
  product,
  productsMenu,
  anchorEl,
  isMenuOpen,
  onOpenMenu,
  onCloseMenu,
  onSelectProduct,
  onEditPlanClick,
}: ProductHeaderProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onEditPlanClick();
    onOpenMenu(event.currentTarget);
  };

  return (
    <Grid size={{ xs: 12, sm: 9.5 }}>
      <FlexGrid container justifyContent="left" alignItems="baseline">
        <Title>{product.title}</Title>

        <MenuButton
          id="menu-button"
          aria-controls={isMenuOpen ? "product-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? "true" : undefined}
          onClick={handleClick}
        >
            {isMenuOpen ? (
                <img src={ArrowUp} alt="seta-acima" />
            ) : (
                <img src={ArrowDown} alt="seta-abaixo" />
            )}
            <span style={{ marginLeft: "5px" }}>Editar Plano</span>
        </MenuButton>

        <StyledMenu
          id="product-menu"
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={onCloseMenu}
          slotProps={{
            list: {
              "aria-labelledby": "menu-button",
            }
          }}
        >
          {productsMenu.map((item, index) => (
            <div key={item}>
              <StyledMenuItem onClick={() => onSelectProduct(item)}>
                <Item>{item}</Item>
              </StyledMenuItem>

              {index < productsMenu.length - 1 && (
                <MenuDivider orientation="horizontal" />
              )}
            </div>
          ))}
        </StyledMenu>
      </FlexGrid>

      <Subtitle>{product.subtitle}</Subtitle>
    </Grid>
  );
};